import React, { useRef, useCallback, useEffect } from 'react';
import { floor, map, size } from 'lodash';

import DealAgentChatAnswer from './components/chatAnswer';
import { DealAgentChat } from 'src/types/dealAgent';
import styles from './styles.module.scss';

interface DealAgentChatProps {
    chats: DealAgentChat[];
}

const AgentChat: React.FC<DealAgentChatProps> = ({
    chats,
}) => {
    const chatContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        chatContainerRef.current?.scrollTo({
        top: chatContainerRef.current.scrollHeight,
        behavior: "smooth",
        });
    }, [chats]);


    return (
        <>
            { size(chats) === 0 ? <span className={styles.empty}>Ask anything about this deal...</span>
            :  <div ref={chatContainerRef} className={styles.chatContainer} > 
                { map(chats, (chat, index) => (
                    <React.Fragment key={chat.id}>
                        <DealAgentChatAnswer
                            index={index}
                            chat={chat}
                            skipTypewriting={false}
                            showDivider={size(chats) !== index+1}
                        />
                    </React.Fragment>
                ))} 
            </div> }
        </>
    );
};

export default AgentChat;
